import React from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import get from 'lodash/get';

import { useComponentTheme } from '../useComponentTheme';

type Props = {
  src?: string,
  alt: string,
  size: 'xsmall' | 'small' | 'medium',
  className: string | null,
  mode: 'default' | 'VerticalSideNav',
};

export const Logo = ({ src, alt, size, className, mode }: Props) => {
  const theme = useTheme();
  const componentTheme = useComponentTheme(theme => theme.components.Logo, mode);
  const componentThemeBySize = get(componentTheme, size);

  return (
    <picture className={className}>
      <source srcSet={get(theme, ['logo', 'image.mobile'])} media={`(${theme.breakpoint.mobile})`} />
      <source srcSet={get(theme, ['logo', 'image.kiosk'])} media={`(${theme.breakpoint.kiosk})`} />
      <Img
        size={size}
        src={src || get(theme, 'logo.image')}
        alt={alt}
        data-test="logo"
        componentTheme={componentThemeBySize}
      />
    </picture>
  );
};

const Img = styled('img')`
  max-height: ${({ componentTheme }) => componentTheme.maxHeight};
  min-width: ${({ componentTheme }) => componentTheme.minWidth};
  max-width: ${({ componentTheme }) => componentTheme.maxWidth};
`;

Logo.defaultProps = {
  alt: null,
  size: 'small',
  className: null,
};
